import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const POINTS = [
  { icon: 'UserPlus', key: 'auth.signupLead' },
  { icon: 'Sparkles', key: 'auth.signupSee' },
  { icon: 'Phone', key: 'auth.signupCall' },
  { icon: 'CreditCard', key: 'auth.signupNoCard' },
];

const RegisterPitch = () => {
  const { t } = useTranslation();

  return (
    <ul className="mb-6 md:mb-8 space-y-3">
      {POINTS.map((point) => (
        <li key={point.key} className="flex items-center gap-3">
          <span className="inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-card text-primary shadow-elevation-sm border border-border">
            <Icon name={point.icon} size={16} />
          </span>
          <p className="text-sm md:text-[15px] leading-relaxed text-foreground/80 text-left">
            {t(point.key)}
          </p>
        </li>
      ))}
    </ul>
  );
};

export default RegisterPitch;
